import { Component, OnInit } from '@angular/core';
import {ApiPathsService} from "../../api-paths.service";
import { ApiRestService } from '../_services/api-rest.service';
import {DatePipe} from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { Bilancio } from '../Models/Bilancio';
import {ToastrService} from "ngx-toastr";
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";





@Component({
  selector: 'app-report-cliente',
  templateUrl: './report-cliente.component.html',
  styleUrls: ['./report-cliente.component.scss']
})
export class ReportClienteComponent implements OnInit {
   saldo:number;
   report : any = {
    /*clienteObject: {id: 286, nominativo: "Anna Romano"},
    saldo: 0,
    statoObject: {id:'A', label:'Approvato'},
    dataFine: "yyyy-mm-dd",
    cassa: 0,
    fattureObject: [
        {data_prevista:"2024/09/02", voci:[{quantita:5,nome:'bene'}, {quantita:0,nome:'bene'}]},
        {data_prevista:"2024/09/03", voci:[{quantita:3,nome:'bene1'}, {quantita:2,nome:'bene1'}]}
    
    ]*/
   }

   riepilogo:any;
   filtro : any = {};
   strutture : any = [];
   ospiti : any = [];
   stato = [
    {id:'I', label:'Approvato'},
    {id:'P', label:'Validato'}
   ]
   dropSetting: IDropdownSettings= { singleSelection: false, singleOutput: false, idField: 'id', textField: 'nominativo',  allowSearchFilter: true}
   settingsDrop: IDropdownSettings= { singleSelection: true, singleOutput: true, idField: 'id', textField: 'label',  allowSearchFilter: false}

   constructor(
    private apiPaths:ApiPathsService,
   ){}


  ngOnInit(){
    this.filtro.stato = []
    this.apiPaths.ClassicPost('/anagrafica/clienti/struttura/list', {page : 0, size : 10}).subscribe(
        data =>{
            this.strutture = data.data
        }
    )
    this.apiPaths.ClassicPost('/anagrafica/clienti/list', {
        page: 0,
        size: 10,
        ruolo: 'C',
        inseriti: true,
      }).subscribe(data => {
            this.ospiti = data.data
            console.log(this.ospiti)
        }
    )
    /*if(this.report)
      this.saldo = this.calculateSaldo()*/


  }

  /*calculateSaldo(){
    let saldo = 0
    this.report.fattureObject.forEach(x =>
        {
            saldo += x.voci[0].prezzo - x.voci[1].prezzo
        })
    return saldo
  }*/

  Refresh(){
    let id_ospiti = []
    const periodo = this.filtro.inizio && this.filtro.fine ? true : false
    /*if(this.filtro?.stato.length > 1 || this.filtro?.stato.length == 0)
      stato = null*/
    console.log("Filtro Stato", this.filtro.stato);
  
    if(this.filtro?.ospite){
      id_ospiti = this.filtro?.ospite?.map(x => {return x.id})
    }

    console.log("Ospite", this.filtro.ospite)
    this.apiPaths.ClassicPost('/primanota/bilancio/cliente/list',{
        page:0, 
        size:10, 
        clienti: id_ospiti,
        periodo: periodo, 
        inizio:this.filtro.inizio, 
        fine:this.filtro.fine,
        stato: this.filtro.stato.id
    }).subscribe(
        data => {
            this.report = data; 
        }
    )
    //this.saldo = this.calculateSaldo()

  }


}
